module.exports = __webpack_public_path__ + "static/media/phone-call.3376a502.svg";